import Model from 'flarum/common/Model';

export default class MeritBadge extends Model {
    name = Model.attribute<string>('name');
    color = Model.attribute<string>('color');
    icon = Model.attribute<string>('icon');
    createdAt = Model.attribute<string>('createdAt');
}
